import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;
export const ContainerSidebar = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
`;

export const Block = styled.div`
  background: #fff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  position: fixed;
  left: 24px;
  bottom: 24px;
  height: 605px;
  width: 1158px;
  z-index: 900;
  cursor: auto;
`;
export const CircleDiv = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  color: ${beam.color.pureWhite};
  background: ${beam.color.primaryBlue};

  border-radius: 50%;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  font-size: 10px;
  font-weight: 700;
  right: -5px;
  bottom: -5px;
  width: 14px;
  height: 14px;
`;

export const ButtonText = styled.h3`
  margin-right: 8px;
  color: ${beam.font.link};
  opacity: 1;
  font-size: 14px;
  cursor: pointer;
`;
